__turbopack_context__.v({
  "faqWrapper": "jypDFq_faqWrapper",
});
